import { render, staticRenderFns } from "./SingleRemitterEmailComponent.vue?vue&type=template&id=369d0152"
import script from "./SingleRemitterEmailComponent.vue?vue&type=script&lang=js"
export * from "./SingleRemitterEmailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports